
import { HelpPanelTopicOptions, UniqueTourIdentifiers } from '../../common/Constants';
import { constants } from '../../common/Localization';
import { Tour } from './GuidedTour';
import { getIndexedId, HotspotIds } from './HotspotIds';

export type PageTourMapping = {[key in HelpPanelTopicOptions]? : Tour[]}

const fileImportTour: Tour = new Tour(
    UniqueTourIdentifiers.FILE_IMPORT_TOUR,
    constants.IMPORT_FROM_FILE,
    constants.IMPORT_FROM_FILE_DESCRIPTION,
    [
        {
            title: constants.DOWNLOAD_SAMPLE_FILE,
            steps: [
                {
                    title: constants.DOWNLOAD_SAMPLE_FILE,
                    content: constants.DOWNLOAD_SAMPLE_FILE_CONTENT,
                    hotspotId: HotspotIds.SAMPLE_FILES_DOWNLOAD
                }
            ],
        },
        {
            title: constants.IMPORT_SERVERS_DATA,
            steps: [
                {
                    title: constants.UPLOAD_SERVERS_DATA,
                    content: constants.UPLOAD_SERVERS_DATA_CONTENT,
                    hotspotId: HotspotIds.FILE_UPLOAD_BUTTON
                },
                {
                    title: constants.SELECT_SHEET,
                    content: constants.SELECT_SHEET_CONTENT,
                    hotspotId: HotspotIds.SELECT_SHEET_HEADER
                },
                {
                    title: constants.RECOMMENDED_HEADER_MAPPING,
                    content: constants.RECOMMENDED_HEADER_MAPPING_CONTENT,
                    hotspotId: HotspotIds.RECOMMENDED_HEADER_MAPPING
                }
            ]
        },
        {
            title: constants.CONFIRM_IMPORT,
            steps: [
                {
                    title: constants.REVIEW_AND_CONFIRM,
                    content: constants.REVIEW_AND_CONFIRM_CONTENT,
                    hotspotId: getIndexedId(HotspotIds.WIZARD_NEXT_BUTTON, 3)
                }
            ]
        }
    ],
);

// define which page a tour is in the info panel here
const toursOnEachPage: PageTourMapping = {
    import_from_file: [fileImportTour]
};


export { toursOnEachPage };
